import { DashboardModuleConfiguration } from '@dreryk/egabinet-dashboard-frontend-api';

export const currentHealthcareProviderModuleIndicatorVisitor = (
   dashboardModuleConfiguration: DashboardModuleConfiguration | null | undefined
) => <ACCEPT>(indicator: { visitPsychiatricModule: () => ACCEPT; visitNeurologicalModule: () => ACCEPT }) => {
   if (!dashboardModuleConfiguration) {
      return null;
   }

   if (dashboardModuleConfiguration.neurologicalModuleEnabled) {
      return indicator.visitNeurologicalModule();
   }

   if (dashboardModuleConfiguration.psychiatricModuleEnabled) {
      return indicator.visitPsychiatricModule();
   }

   return null;
};
